module.exports = __webpack_public_path__ + "img/5497a157d56b14c581886f3eaed517df.png";